import PREVIOUS_SEARCH_COUNT from 'constants/previous-search-count';
import HOTEL_SEARCH_PARAMS from './../config/hotel-search-params';

export default function HotelSearchFormController(
    $scope,
    $state,
    $rootScope,
    hotelsFactory,
    userService,
    l10nService,
    hotelsAPI,
    hotelsOptions,
    premierInnFormChecker,
    hotelResultService,
    travelodgeFormChecker,
) {
    'ngInject';

    const vm = this;
    const MONTHS_IN_ADVANCE = 11;
    const DEFAULT_SEARCH_RADIUS = 0;
    const regionalSettings = userService && userService.getRegionalSettings();
    const initialOptions = hotelsFactory.options;
    const initialParams = getInitialParams();
    const address = hotelsFactory.address;
    const altAddress = hotelsFactory.altAddress;
    const addressText = hotelsFactory.addressText;
    const watcher = hotelsFactory.watcher;

    $rootScope.pageHeading = l10nService.localize('Hotels search');

    Object.assign(vm, {
        openDropdown: null,
        repeatSearch,
        $onInit,
    });

    function $onInit() {
        vm.openDropdown = hotelsFactory.openDropdown;
        vm.placeTypes = [];
        hotelsFactory.openDropdown = null;
    }

    getAllSearches();
    getFrequentLocation();

    $scope.changeValue = changeValue;
    $scope.getCaption = getCaption;
    $scope.frequentLocation = [];
    $scope.previousSearches = [];
    $scope.maxTravellerAmount = hotelsFactory.maxTravellerAmount;

    $scope.hotelSearchForm = {
        params: initialParams,
        options: initialOptions,
        address,
        altAddress,
        addressText,
        administrativeAreaLevel1: '',
        countryCode: '',
        cityName: '',
        placeId: '',
    };

    const coDate = $scope.hotelSearchForm.params.checkInDate
        ? moment($scope.hotelSearchForm.params.checkInDate, regionalSettings.dateFormat)
        : moment();

    $scope.hotelsFormChecker = {
        form: $scope.hotelSearchForm,
        errorElementSelector: '.formWarnings',
        errorCheckers: [premierInnFormChecker, travelodgeFormChecker],
    };

    function repeatSearch(search) {
        const {LocationName, AdministrativeAreaLevel1, CountryCode, CityName, roomsQuantity, occupantsQuantity, PlaceId} = search;
        $scope.findHotels(search, LocationName, LocationName, AdministrativeAreaLevel1, CountryCode, CityName, roomsQuantity, occupantsQuantity, PlaceId);
    }

    function changeValue(name, selected) {
        $scope.hotelSearchForm.params[name] = selected.value;
        if ($scope.maxTravellerAmount && $scope.hotelSearchForm.options.occupantsSelected.value * $scope.hotelSearchForm.options.roomsListSelected.value > $scope.maxTravellerAmount) {
            $scope.hotelSearch.occupantsPerRoom.$setValidity('tooManyOccupants', false);
        } else {
            $scope.hotelSearch.occupantsPerRoom.$setValidity('tooManyOccupants', true);
        }
    }

    function getCaption(result) {
        return result.LocationName;
    }

    function getInitialParams() {
        const formData = hotelsFactory.getFormData();
        if (formData) {
            formData.hotelName = '';
            return formData;
        }
        return hotelsFactory.params;
    }

    $scope.hotelSearchForm.options.roomsListSelected = angular.copy(_.find($scope.hotelSearchForm.options.roomsList, {value: '' + initialParams.roomsQuantity}));

    $scope.hotelSearchForm.options.occupantsSelected = angular.copy(_.find($scope.hotelSearchForm.options.occupantsOptions, {value: '' + initialParams.occupantsQuantity}));

    $scope.typeaheadHelpers = {
        addressQuery: '',
    };

    $scope.optionsCI = {
        placeholder: l10nService.localize('Check-In'),
        required: true,
        months: 2,
        start: coDate,
        after: moment().add({days: -1}),
        before: moment().add({months: MONTHS_IN_ADVANCE}),
        dependentPikers: ['optionsCO'],
        shiftDependentDays: 1,
    };

    $scope.optionsCO = {
        placeholder: l10nService.localize('Check-Out'),
        required: true,
        months: 2,
        start: coDate,
        after: coDate,
        before: moment().add({months: MONTHS_IN_ADVANCE}),
    };

    $scope.dummy = undefined;

    $scope.onRecentSearchSelect = function(addressViewModel) {
        return function(location) {
            addressViewModel.$setValidity('editable', true);

            const {hotelName, MaximumRadius, occupantsQuantity, roomsQuantity} = $scope.hotelSearchForm && $scope.hotelSearchForm.params;

            Object.assign($scope.hotelSearchForm, {
                countryCode: location.CountryCode,
                cityName: location.CityName,
                administrativeAreaLevel1: location.AdministrativeAreaLevel1,
                address: location.LocationName,
                addressText: location.LocationName,
                altAddress: location.LocationName,
                placeId: location.PlaceId,
                params: {
                    longitude: location.LocationLongitude,
                    latitude: location.LocationLatitude,
                    hotelName,
                    MaximumRadius,
                    occupantsQuantity,
                    roomsQuantity,
                },
            });
        };
    };

    $scope.findHotels = function(params, searchAddress, altSearchAddress, administrativeAreaLevel1, countryCode, cityName, roomsQuantity, occupantsQuantity, placeId) {  // eslint-disable-line
        hotelsFactory.address = searchAddress;
        hotelsFactory.altAddress = altSearchAddress;

        hotelResultService
            .getFilterProperties()
            .forEach((filter) => delete params[filter]);

        params.Location = searchAddress;
        params.administrativeAreaLevel1 = administrativeAreaLevel1 || $scope.hotelSearchForm.params.administrativeAreaLevel1;
        params.countryCode = countryCode || $scope.hotelSearchForm.params.countryCode;
        params.roomsQuantity = roomsQuantity || $scope.hotelSearchForm.params.roomsQuantity;
        params.occupantsQuantity = occupantsQuantity || $scope.hotelSearchForm.params.occupantsQuantity;
        params.cityName = cityName || $scope.hotelSearchForm.params.cityName;
        params.HotelSorting = 0;
        params.min = HOTEL_SEARCH_PARAMS.DEFAULT_SEARCH_PARAMS.MIN;
        params.max = HOTEL_SEARCH_PARAMS.DEFAULT_SEARCH_PARAMS.MAX;
        params.Radius = DEFAULT_SEARCH_RADIUS;

        params.placeId = _.intersection(vm.placeTypes, hotelsFactory.placeTypesWithId).length > 0
            ? placeId || $scope.hotelSearchForm.placeId || params.placeId
            : null;

        $scope.hotelSearchForm.params = angular.copy(params);
        $scope.hotelSearchForm.address = searchAddress;
        $scope.hotelSearchForm.altAddress = altSearchAddress;
        $scope.hotelSearchForm.administrativeAreaLevel1 = administrativeAreaLevel1;
        $scope.hotelSearchForm.cityName = cityName;
        $scope.hotelSearchForm.countryCode = countryCode;

        $scope.hotelSearchForm.options.roomsListSelected = angular.copy(_.findWhere(
            $scope.hotelSearchForm.options.roomsList,
            {value: '' + params.roomsQuantity}
        ));

        $scope.hotelSearchForm.options.occupantsSelected = angular.copy(_.findWhere(
            $scope.hotelSearchForm.options.occupantsOptions,
            {value: '' + params.occupantsQuantity}
        ));
        $state.go('main.hotels.results', params, {inherit: false});
    };

    $scope.$watchGroup(['hotelSearchForm.params.checkInDate', 'hotelSearchForm.params.checkOutDate'],
        watcher.dateComparison.bind($scope.hotelSearchForm)
    );

    $scope.$watch('hotelSearchForm.params.checkInDate', function(newVal) {
        if (newVal) {
            const date = moment(newVal, regionalSettings.dateFormat);
            if (date.date() === date.endOf('month').date()) {
                $scope.optionsCO.start = date.add({days: 1});
            }
        }
    });

    function getAllSearches() {
        hotelsAPI.getPreviousSearches(PREVIOUS_SEARCH_COUNT.EXTENDED).then(setPreviousSearchData);
    }

    function getFrequentLocation() {
        hotelsAPI.getFrequentLocations().then(({data}) => $scope.frequentLocation = data);
    }

    function setPreviousSearchData({data}) {
        $scope.previousSearches = transformPreviousSearch(data);
    }

    function transformPreviousSearch(previousSearches) {
        const paramsToTransform = ['Longitude', 'Latitude', 'Radius', 'HotelName', 'OccupantsQuantity',
            'RoomsQuantity', 'CheckOutDate', 'CheckInDate'];

        return _.map(previousSearches, (hotel) => {
            _.forEach(paramsToTransform, (param) => {
                hotel[param.charAt(0).toLowerCase() + param.slice(1)] = hotel[param];
                delete hotel[param];
            });

            const {dateFormat} = regionalSettings;
            hotel.checkInDate = moment(hotel.checkInDate).format(dateFormat);
            hotel.checkOutDate = moment(hotel.checkOutDate).format(dateFormat);
            return hotel;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/hotels/controllers/hotelSearchForm.js